import { Form } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/$components';
import {
	Box,
	Typography,
	Spacer,
	InputSelect,
	InputField,
	Button,
	DatePicker,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ArrowLeft } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { rem } from '@helpers';
import { Anything } from '@types';
import { useRequestToCallCloseHelper } from './requestToCallClose.helper';
import { RequestToCallSuccess } from './requestToCallInfoSuccess';
import { Link } from '@components';
interface RequestToCallCloseProps {
	hideDisclaimer: () => void;
}
export const RequestToCallClose: React.FC<RequestToCallCloseProps> = (props) => {
	const { hideDisclaimer } = props;
	const { palette } = useTheme();
	const {
		buildDialingPhoneCodes,
		resources,
		buildTimeCodes,
		timeSchedule,
		indicative,
		date,
		name,
		form,
		clickToCallAgentClosedSuccess,
		statusDate,
		messageErrorDate,
		isDisabled,
		popupMenuRefIndicative,
		popupMenuRefTime,
		getInputProps,
		back,
		handlePressIndicative,
		handlePressTime,
		handleOnSubmit,
		onDateChange,
		onClearDate,
	} = useRequestToCallCloseHelper();

	return (
		<>
			{clickToCallAgentClosedSuccess ? (
				<RequestToCallSuccess nameToContact={name} />
			) : (
				<Box
					styles={{
						flexDirection: 'column',
						minHeight: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Box styles={{ flexDirection: 'column', alignItems: 'center', marginBottom: rem(48) }}>
						<Typography appearance="headline-200-02">{resources.title}</Typography>
						<Spacer vertical={8} />
						<Typography
							appearance="body-100-02"
							alternativeStyleProperties={{ color: palette.global.ui9 } as Anything}
						>
							{resources.subtitle}
						</Typography>
					</Box>
					<Form
						name={form.name}
						ref={form.ref}
						style={{ flexDirection: 'column', alignItems: 'center', width: rem(493) }}
					>
						<Box>
							<Box>
								<DatePicker
									date={date?.format('DD/MM/YYYY')}
									mode="default"
									dateFormat="DD/MM/YYYY"
									hideOnDaySelection
									inputProps={{
										label: resources.dateLabel,
										readOnly: true,
										status: statusDate,
										errorMessage: messageErrorDate,
									}}
									onDateChange={onDateChange}
									onClearButtonPress={onClearDate}
								/>
							</Box>
							<Spacer horizontal={24} />
							<Box>
								<InputSelect
									mode="default"
									ref={popupMenuRefTime}
									inputField={{
										label: resources.timeLabel,
										value: timeSchedule,
									}}
									onPress={(id) => handlePressTime(id)}
									popupMenu={{
										popupMenuHeight: { maxHeight: rem(150) },
										hideOnClick: true,
										items: buildTimeCodes,
										zIndex: 10,
									}}
								/>
							</Box>
						</Box>
						<Box
							styles={{
								margin: rem(24, 0),
								width: '100%',
							}}
						>
							<Typography appearance="body-75-03">{resources.titleForm}</Typography>
						</Box>
						<Box>
							<div>
								<InputField
									mode="default"
									label={resources.inputLabelName}
									{...(getInputProps('name') as Anything)}
								/>
							</div>
							<Spacer horizontal={24} />
							<div>
								<InputSelect
									mode="default"
									ref={popupMenuRefIndicative}
									inputField={{
										label: resources.inputCountry,
										value: indicative,
										containerProps: {
											width: rem(105),
										},
									}}
									onPress={(id) => handlePressIndicative(id)}
									popupMenu={{
										popupMenuHeight: { maxHeight: rem(150) },
										hideOnClick: true,
										items: buildDialingPhoneCodes,
										zIndex: 10,
									}}
								/>
							</div>
							<Spacer horizontal={rem(8)} />
							<div>
								<InputField
									mode="number"
									inputProps={{
										maxLength: indicative === '+351' ? 9 : undefined,
									}}
									label={resources.inputLabelContact}
									{...(getInputProps('phoneNumber') as Anything)}
								/>
							</div>
						</Box>
						<Box styles={{ width: '100%' }}>
							<InputField label={resources.inputLabelEmail} {...(getInputProps('email') as Anything)} />
						</Box>
						<Spacer vertical={rem(56)} />
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<Box>
								<Button
									disabled={isDisabled}
									onPress={() => {
										handleOnSubmit();
										hideDisclaimer();
									}}
								>
									{resources.sendRequest}
								</Button>
							</Box>
							<Spacer vertical={rem(56)} />
							<Box>
								<Link onClick={() => back()}>
									<Box styles={{ alignItems: 'center' }}>
										<ArrowLeft fill={palette.primary.p1} width={rem(24)} height={rem(24)} />
										<Spacer horizontal={rem(8)} />
										<Typography appearance="body-100-03" colorsLevel="linkDefault">
											{resources.linkBack}
										</Typography>
									</Box>
								</Link>
							</Box>
						</Box>
					</Form>
				</Box>
			)}
		</>
	);
};
